import React, {createContext, useContext, useMemo, useState} from "react";

export const OrderDataContext = createContext(null);

const OrderDataProvider = props => {
    const [senderInfo, setSenderInfo] = useState();
    const [receiverInfo, setReceiverInfo] = useState();

    const senderDataValue = useMemo(() => ({senderInfo, setSenderInfo}), [senderInfo]);
    const receiverDataValue = useMemo(() => ({receiverInfo, setReceiverInfo}), [receiverInfo]);

    return  <OrderDataContext.Provider value={{senderDataValue, receiverDataValue}} {...props} />
};
export const useOrderDataContext = () => useContext(OrderDataContext);
export default OrderDataProvider;